import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "No, eGeeTouch® smart luggage locks are rated IP 44 water resistant which essentially means it is able to withstand water splashes or a few minutes of rain. Its electronic board is coated with a layer of water resistant material. Likewise to most electronic products, when splashed with or submerged in water for prolonged periods, the batteries drain out quickly. Simply ensure the lock is completely dry and then install new batteries to regain its function. However, for some models, you may use the optional IP65 waterproof casing to make your smart padlock waterproof and suitable for outdoor use. For more info on Tests & Certifications, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "いいえ、eGeeTouch® スマート ラゲッジ ロックは IP 44 の耐水性を備えており、基本的に水しぶきや数分間の雨に耐えられることを意味します。その電子基板は耐水性素材の層でコーティングされています。ほとんどの電子製品と同様に、長時間水をかけたり水に浸したりすると、バッテリーが急速に消耗します。ロックが完全に乾いていることを確認し、新しい電池を取り付けるだけで機能が回復します。ただし、一部のモデルでは、オプションの IP65 防水ケースを使用して、スマート南京錠を防水にし、屋外での使用に適したものにすることができます。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "No, los candados de equipaje inteligentes eGeeTouch® tienen una clasificación de resistencia al agua IP 44, lo que esencialmente significa que son capaces de soportar salpicaduras de agua o unos minutos de lluvia. Su placa electrónica está recubierta con una capa de material resistente al agua. Al igual que con la mayoría de los productos electrónicos, cuando se salpican o se sumergen en agua durante períodos prolongados, las baterías se agotan rápidamente. Simplemente asegúrese de que la candado esté completamente seca y luego instale baterías nuevas para recuperar su función. Sin embargo, para algunos modelos, puede utilizar la carcasa impermeable IP65 opcional para que su candado inteligente sea resistente al agua y adecuado para uso en exteriores. Para obtener más información sobre pruebas y certificaciones, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q14_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q14_component;
